import React, { memo, useContext, useEffect, useReducer } from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import './css/SocialsComponent2.css';
import ReactPlayer from 'react-player';
import parse from 'html-react-parser';
import { Helmet } from 'react-helmet';
import InstagramIcon from '../../../../assets/socialIcons/coloredInstagramIcon.png';
import YoutubeIcon from '../../../../assets/socialIcons/redYoutubeIcon.png';
import TwitterIcon from '../../../../assets/socialIcons/blueTwitterIcon.png';
import FacebookIcon from '../../../../assets/socialIcons/blueFacebookIcon.png';
import TiktokIcon from '../../../../assets/socialIcons/coloredTiktokIcon.png';
import { context } from '../../../../globalState/GlobalState';
import { getTwitterHandle, getYoutubeHandle } from '../../../../catalog/Social';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { sendCustomAnalytics } from '../../../../catalog/Analytics';
import SocialsVideoPopup from '../socialsVideoPopUp/SocialsVideoPopup';
import { getYoutubeUploadsBetterAPI } from '../../../apiCalls/YoutubeAPICalls';

const initialState = {
    videos: [],
    videoRows: 1,
    showVideoPopup: false,
    videoTitle: '',
    videoURL: '',
};

function reducer(state, action) {
    switch (action.type) {
        case 'setVideos':
            return { ...state, videos: action.videos };
        case 'addMoreVideos':
            return { ...state, videoRows: state.videoRows + 1 };
        case 'showVideoPopup':
            return { ...state, showVideoPopup: true, videoTitle: action.title, videoURL: action.url };
        case 'hideVideoPopup':
            return { ...state, showVideoPopup: false, videoTitle: action.title, videoURL: action.url };
        default:
            return initialState;
    }
}

const SocialsComponent2 = () => {
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);

    useEffect(() => {
        if (isValidObject(window) && isValidObject(window.FB) && isValidObject(window.FB.XFBML)) {
            window.FB.XFBML.parse();
        }
        if (isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.youtubeURL)) {
            getYoutubeUploadsBetterAPI(getYoutubeHandle(globalState.socials.youtubeURL), setState);
        }
    }, [globalState]);

    const getTitle = (title) => {
        if (title.length > 70) {
            return `${title.substr(0, 70)}...`;
        }
        return title;
    };

    return (
        <>
            <Helmet>
                {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.instagramWidget) ? parse(globalState.socials.instagramWidget) : null}
            </Helmet>

            <div className="socials-component2-container full-width bg-lightsilver p-t-20px p-b-20px curve-border-20px">
                <div className="socials-component2-buttons m-b-50px">
                    {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.twitterURL) ? (
                        <div className="socials-component2-button-container m-t-5px m-b-5px m-l-5px m-r-5px">
                            <a className="socials-component2-button text-gray text-no-underline font-size-m text-uppercase p-l-15px p-r-15px" href={`https://twitter.com/intent/follow?&ref_src=twsrc%5Etfw&screen_name=${getTwitterHandle(globalState.socials.twitterURL)}&tw_p=followbutton`} target="_blank" rel="noreferrer">
                                <img src={TwitterIcon} alt="Follow on Twitter" />
                                {' '}
                                Follow
                            </a>
                        </div>
                    ) : null}
                    {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.youtubeURL) ? (
                        <div className="socials-component2-button-container m-t-5px m-b-5px m-l-5px m-r-5px">
                            <a className="socials-component2-button text-gray text-no-underline font-size-m text-uppercase p-l-15px p-r-15px" href={`${globalState.socials.youtubeURL}?sub_confirmation=1&feature=subscribe-embed-click`} target="_blank" rel="noreferrer">
                                <img className="youtube" src={YoutubeIcon} alt="Subscribe on Youtube" />
                                {' '}
                                Subscribe
                            </a>
                        </div>
                    ) : null}
                    {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.facebookURL) ? (
                        <div className="socials-component2-button-container m-t-5px m-b-5px m-l-5px m-r-5px">
                            <a className="socials-component2-button text-gray text-no-underline font-size-m text-uppercase p-l-15px p-r-15px" href={globalState.socials.facebookURL} target="_blank" rel="noreferrer">
                                <img src={FacebookIcon} alt="Like on Facebook" />
                                {' '}
                                Like
                            </a>
                        </div>
                    ) : null}
                    {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.instagramURL) ? (
                        <div className="socials-component2-button-container m-t-5px m-b-5px m-l-5px m-r-5px">
                            <a className="socials-component2-button text-gray text-no-underline font-size-m text-uppercase p-l-15px p-r-15px" href={globalState.socials.instagramURL} target="_blank" rel="noreferrer">
                                <img src={InstagramIcon} alt="Follow on Instagram" />
                                {' '}
                                Follow
                            </a>
                        </div>
                    ) : null}
                    {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.tiktokURL) ? (
                        <div className="socials-component2-button-container m-t-5px m-b-5px m-l-5px m-r-5px">
                            <a className="socials-component2-button text-gray text-no-underline font-size-m text-uppercase p-l-15px p-r-15px" href={globalState.socials.tiktokURL} target="_blank" rel="noreferrer">
                                <img src={TiktokIcon} alt="Follow on TikTok" />
                                {' '}
                                Follow
                            </a>
                        </div>
                    ) : null}
                </div>
                {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.instagramWidget) ? (
                    <div className="socials-component2-widget socials-component2-instagram m-b-50px">
                        <div className="socials-component2-widget-title full-width m-t-10px p-l-30px m-b-10px">
                            <img className="icon m-r-20px" src={InstagramIcon} alt="Follow on Twitter" />
                            <p className="font-size-2xl m-t-0 m-b-0">Posts</p>
                        </div>
                        {parse(globalState.socials.instagramWidget)}
                    </div>
                ) : null}
                {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.twitterURL) ? (
                    <div className="socials-component2-widget box-shadow-black curve-border-5px bg-white m-b-50px">
                        <div className="socials-component2-widget-title full-width m-t-10px p-l-30px m-b-10px">
                            <img className="icon m-r-20px" src={TwitterIcon} alt="Follow on Twitter" />
                            <p className="font-size-2xl m-t-0 m-b-0">Posts</p>
                        </div>
                        <TwitterTimelineEmbed
                            sourceType="url"
                            url={globalState.socials.twitterURL}
                            autoHeight
                            noHeader
                            noFooter
                            noScrollbar
                            options={{ id: `profile:${getTwitterHandle(globalState.socials.twitterURL)}` }}
                        />
                    </div>
                ) : null}
                {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.facebookURL) ? (
                    <div className="socials-component2-widget box-shadow-black curve-border-5px bg-white m-b-50px">
                        <div className="socials-component2-widget-title full-width m-t-10px p-l-30px m-b-10px">
                            <img className="icon m-r-20px" src={FacebookIcon} alt="Like on Facebook" />
                            <p className="font-size-2xl m-t-0 m-b-0">Posts</p>
                        </div>
                        <div
                            className="fb-like-box full-width"
                            data-href={globalState.socials.facebookURL}
                            // data-tabs="timeline, events, messages"
                            data-width="330"
                            data-height="480"
                            data-stream="true"
                            data-small-header="true"
                            data-adapt-container-width="true"
                            data-hide-cover="true"
                            data-show-facepile="false"
                        >
                            <blockquote cite={globalState.socials.facebookURL} className="fb-xfbml-parse-ignore"><a href={globalState.socials.facebookURL}>Facebook</a></blockquote>
                        </div>
                    </div>
                ) : null}
                {state.videos.length > 0 ? (
                    <div className="socials-component2-widget socials-component2-videos m-b-50px">
                        <div className="socials-component2-widget-title full-width m-t-10px p-l-30px m-b-10px">
                            <img className="icon m-r-20px" src={YoutubeIcon} alt="Youtube Videos" />
                            <p className="font-size-2xl m-t-0 m-b-0">Videos</p>
                        </div>
                        {state.videos.slice(0, 3).map((video) => {
                            return (
                                <div key={video.url} className="socials-component2-video">
                                    <ReactPlayer
                                        className="socials-component2-video-player"
                                        url={video.url}
                                        controls
                                        width="100%"
                                        height="71%"
                                        pip
                                        light
                                        onClick={() => {
                                            setState({ type: 'showVideoPopup', title: video.title, url: video.url });
                                            sendCustomAnalytics('homepage_video', { videoControl: 'start' });
                                        }}
                                        // onStart={() => {
                                        //     setState({ type: 'showVideoPopup', title: video.title, url: video.url });
                                        //     sendCustomAnalytics('homepage_video', { videoControl: 'start' });
                                        // }}
                                    />
                                    <p className="normal-font-family font-weight-500 font-size-s text-left-align">{getTitle(video.title)}</p>
                                </div>
                            );
                        })}
                    </div>
                ) : null}
                <SocialsVideoPopup open={state.showVideoPopup} title={state.videoTitle} url={state.videoURL} onCancel={() => { setState({ type: 'hideVideoPopup' }); }} />
            </div>
        </>
    );
};

export default memo(SocialsComponent2);
